export const createPromoProfileUrl = () => `promo-page`

export const createPromoReleaseUrl = () => `promo-release`

export const updatePromoReleaseUrl = () => `promo-release`

export const deletePromoReleaseUrl = () => `promo-release`

export const updatePromoPageUrl = () => `promo-page`

export const getPromoPageUrl = () => `promo-page`

export const getPromoPageListUrl = () => `promo-pages`

export const deletePromoPageUrl = () => `promo-page`

export const checkPromoReleaseContainUrl = () => `promo-release/check-contain`
